import { Box, BoxProps } from '@mui/material';

interface DataTableCardProps {
  // Optional style overrides, e.g. to let the card stretch and become a flex
  // column so an empty state can fill and center within the remaining space.
  sx?: BoxProps['sx'];
}

export function DataTableCard({
  children,
  sx,
}: React.PropsWithChildren<DataTableCardProps>) {
  return <Box sx={sx}>{children}</Box>;
}
